import React from 'react';

import { useScrollHandler } from './useScrollHandler';

const MAX_VISIBLE_SCROLL_TOP = 100;
const MAX_VISIBLE_BOTTOM_OFFSET = 150;

export const useHideOnScroll = (onChange: (isVisible: boolean) => void) => {
  const lastScrollTop = React.useRef(0);
  const wrapperRef = React.useRef<HTMLDivElement | null>(null);

  const onScroll = React.useCallback(() => {
    if (wrapperRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = wrapperRef.current;

      const isCloseToTop = scrollTop < MAX_VISIBLE_SCROLL_TOP;
      const isAfterScrollUp = scrollTop < lastScrollTop.current;
      const isCloseToBottom = scrollHeight - scrollTop - clientHeight < MAX_VISIBLE_BOTTOM_OFFSET;

      const isVisible = isCloseToTop || isAfterScrollUp || isCloseToBottom;

      lastScrollTop.current = scrollTop;
      onChange(isVisible);
    }
  }, [onChange]);

  useScrollHandler(wrapperRef, onScroll);

  return wrapperRef;
};
